import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { getAllConsentKey } from "./useGetAllConsent";
import { ConsentWrite } from "src/pages/Authentication/Consents";

type CreateConsents = {
    consents: ConsentWrite[];
};

export const useCreateBatchConsent = () => {
    const queryClient = useQueryClient();
    const query = useMutation({
        mutationFn: async (options: CreateConsents) => {
            const { consents } = options;

            const response = await loggedInApiCall.post(`/api/users/consents`, {
                consents: consents,
            });
            return response;
        },
        onSuccess: () => queryClient.invalidateQueries([getAllConsentKey]),
    });

    return query;
};
